import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api, MOVE } from "@/lib/api";
import { PageHeader, Card, Sel, LedgerTable } from "@/components/common";
import { useAuth } from "@/context/AuthContext";

export default function Ledger() {
  const { myLocs, activeItems, locById } = useAuth();
  const [sp] = useSearchParams();
  const [f, setF] = useState({ location_id: sp.get("loc") || "", item_id: sp.get("item") || "", movement_type: "", ref: "" });
  const [rows, setRows] = useState([]);
  useEffect(() => {
    const p = Object.fromEntries(Object.entries(f).filter(([, v]) => v));
    api.get("/ledger", { params: p }).then((r) => setRows(r.data));
  }, [f]);
  const set = (k) => (v) => setF((x) => ({ ...x, [k]: v }));
  return (
    <div>
      <PageHeader title="Jurnal stok (inventory ledger)" sub="Setiap pergerakan stok tercatat di sini. Saldo stok = jumlah semua entri ledger." />
      <Card className="p-3 mb-3 grid grid-cols-2 md:grid-cols-4 gap-2">
        <Sel testid="ledger-location-filter" value={f.location_id} onChange={set("location_id")} placeholder="Semua lokasi" options={myLocs.map((l) => ({ value: l.id, label: l.name }))} />
        <Sel testid="ledger-item-filter" value={f.item_id} onChange={set("item_id")} placeholder="Semua barang" options={activeItems.map((i) => ({ value: i.id, label: i.name }))} />
        <Sel testid="ledger-type-filter" value={f.movement_type} onChange={set("movement_type")} placeholder="Semua jenis" options={Object.entries(MOVE).map(([v, l]) => ({ value: v, label: l }))} />
        <input className="inp" placeholder="Cari kode referensi…" value={f.ref} onChange={(e) => set("ref")(e.target.value)} data-testid="ledger-ref-filter" />
      </Card>
      <Card><LedgerTable rows={rows} locById={locById} /></Card>
    </div>
  );
}
